export const BASE_URL = 'https://labeddit.herokuapp.com';